export const THINKING_TIMES = [
  '5',
  '10',
  '20',
  '30',
  '60',
  '120',
  '300',
  '600',
] as const;
export const DEFAULT_THINKING_TIME = THINKING_TIMES[0];

export const QUESTION_WEIGHTS = [
  '8',
  '10',
  '18',
  '20',
  '30',
  '40',
  '50',
] as const;
// export const DEFAULT_QUESTION_WEIGHTS = THINKING_TIMES[0];
